module.exports = __webpack_public_path__ + "static/img/legendary.f043f6bc.png";